<template>
  <div :key="key" class="col-12">
    <div v-if="params.erro">
      <p class="text-danger mb-0">Aconteceu algum erro ao importar o protocolo.</p>
      <p> <strong>Por gentileza, tente novamente a operação. Se o erro persistir, informe o suporte sobre o ocorrido</strong> </p>
    </div>
    <span> {{ alert.texto }} </span>
    <span v-if="progress === '100%'" class="badge badge-primary">
      Protocolo: <router-link class="text-white" :to="`/virtus/visualizadorProcesso?numeroProcesso=${formatarProtocolo(params.numeroProtocolo).withoutSlash}`">
        {{ formatarProtocolo(params.numeroProtocolo).formated }}
      </router-link>
    </span>
    <progress-bar
      :key="progress"
      :percentage="progress ? progress : '0%'"
      :danger="blueBar"
      :warning="blueBar"
      :success="greenBar"
      :animated="true"
      class="mt-1 mb-3"
    />
  </div>
</template>

<script>
import { protocoloSpiParse, protocoloSpiParseWithoutSlash } from '@/uteis/converters/ProtocoloConverter'

import progressBar from '@/components/progressBar/ProgressBar'

import { mapState } from 'vuex'

import ProcessoElaboracaoService from '@/services/ProcessoElaboracaoService'

export default {
  components: {
    progressBar
  },

  data () {
    return {
      progress: '0%',
      customClass: {
        'border mt-2 rounded': true
      }
    }
  },

  created () {
    this.service = new ProcessoElaboracaoService()

    if (!this.params.erro) {
      this.$store.commit('MUT_LOADING', 1)
      this.idInterval = setInterval(this.pesquisar, 2000)
    }

    if (this.params.porcentagem) {
      this.progress = this.params.porcentagem
    }
  },

  methods: {
    update (progress, text, erro) {
      if (erro) {
        clearInterval(this.idInterval)
        this.$store.commit('MUT_LOADING', -1)
        this.$store.commit('MUT_NOTIFICATION', {
          alert: {
            type: 'danger',
            texto: erro
          },
          params: {
            numeroProtocolo: this.params.numeroProtocolo,
            erro: erro
          }
        })
        this.progress = progress
        return
      }

      if (progress === '100%') {
        clearInterval(this.idInterval)
        this.progress = progress
        this.$store.commit('MUT_LOADING', -1)
        this.$store.commit('MUT_NOTIFICATION', {
          alert: {
            type: 'success',
            texto: 'Protocolo importado com sucesso'
          },
          component: 'spi-importacao-sucess',
          params: {
            numeroProtocolo: this.params.numeroProtocolo
          }
        })
        return
      }
      this.$store.commit('MUT_NOTIFICATION', {
        alert: {
          type: 'light',
          texto: text
        }
      })
      this.progress = progress
    },

    pesquisar () {
      this.service.statusImportacao(this.params.numeroProtocolo).then((data) => {
        const text = `${data.numeroProtocolo} - ${data.descricaoEtapa}`
        this.update(data.porcentagem, text, data.erro)
      }).catch((err) => {
        console.log(err)
      })
    },

    formatarProtocolo (protocolo) {
      return {
        formated: protocoloSpiParse(protocolo).value,
        withoutSlash: protocoloSpiParseWithoutSlash(protocolo).value
      }
    }
  },

  computed: {
    ...mapState({
      alert: state => state.notification.alert,
      key: state => state.notification.key,
      params: state => state.notification.params
    }),
    greenBar: function () {
      return !this.params.erro ? 'bg-success' : 'bg-danger'
    },
    blueBar: function () {
      return !this.params.erro ? 'bg-info' : 'bg-danger'
    }
  }
}
</script>
